import { safeRandomUUID } from '#pplx/frontend/common/safeRandomUUID.js';
import { logger } from '#pplx/frontend/logger/browser.js';
export class AndroidBridgeAdapter {
    requests = new Map();
    bridge;
    get isAvailable() {
        if (typeof window === 'undefined')
            return undefined;
        return window.cometBridge != null;
    }
    constructor() {
        this.bridge = new Proxy({}, {
            get: (_target, methodName) => {
                return (payload) => {
                    const request_id = safeRandomUUID();
                    const request = {
                        request_id,
                        [methodName]: payload ?? {},
                    };
                    return new Promise((res, rej) => {
                        this.requests.set(request_id, (result) => {
                            if ('error' in result) {
                                rej(new Error(String(result.error)));
                            }
                            else {
                                res(result);
                            }
                        });
                        window.cometBridge?.postMessage(JSON.stringify(request));
                    });
                };
            },
        });
        this.startListenMessages();
    }
    startListenMessages() {
        if (!window.cometBridge) {
            return;
        }
        window.cometBridge.onmessage = (event) => {
            const msg = event.data;
            if (!msg)
                return;
            try {
                const res = JSON.parse(msg);
                const cb = this.requests.get(res.request_id);
                if (cb) {
                    this.requests.delete(res.request_id);
                    cb(res);
                }
                else {
                    console.warn('No callback found for requestId', res.request_id, res);
                    logger.warn('No callback found for requestId', res.request_id, res);
                }
            }
            catch (err) {
                console.warn('Failed to parse bridge response', msg, err);
                logger.warn('Failed to parse bridge response', msg, err);
            }
        };
    }
}
export class IosBridgeAdapter {
    bridge;
    get isAvailable() {
        if (typeof window === 'undefined')
            return undefined;
        return window.webkit?.messageHandlers?.cometBridge != null;
    }
    constructor() {
        this.bridge = new Proxy({}, {
            get: (_target, methodName) => {
                return async (payload) => {
                    const request_id = safeRandomUUID();
                    const request = {
                        request_id,
                        [methodName]: payload ?? {},
                    };
                    const response = await window.webkit?.messageHandlers?.cometBridge?.postMessage(JSON.stringify(request));
                    if (!response) {
                        throw new Error('No response from cometBridge');
                    }
                    return JSON.parse(response);
                };
            },
        });
    }
}
//# sourceMappingURL=bridge.js.map